import { z } from "zod";

export const ItensServicoEmpreendimentoSchema = z.object({
    idsChecklistServico: z.array(z.coerce.number()).nullable().default([]),
    idsBloco: z.array(z.coerce.number()).nullable().default([]),
    idsUnidade: z.array(z.coerce.number()).nullable().default([]),
    quantidade: z.coerce.number().nullable().default(0),
    valorUnitario: z.coerce.number().nullable().default(0),
    salvarPorBloco: z.coerce.number().default(1)

});

export type ItensServicoEmpreendimentoForm = z.infer<typeof ItensServicoEmpreendimentoSchema>;








